import { toDecimalDefaultZero } from './toNumber'

export function formatCurrency(number?: number | null) {
    if (!number) {
        return '$0.00'
    }

    // Use Decimal.js to handle any rounding logic
    const rounded = toDecimalDefaultZero(number).toDP(2).toNumber()

    return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(rounded)
}
